module.exports = ".roundbtn {\n    position: absolute;\n    top: 20px;\n    left: 20px;\n    z-index: 9;\n    width: 40px;\n    height: 40px;\n    background-color: #ffffff;\n    border-radius: 50%;\n    opacity: 1;\n    text-align: center;\n    font-size: 0px;\n    /* border: 1px solid #0a5894; */\n}\n\n.enroll-header {\n    border-radius: 10px 10px 0px 0px;\n    margin-bottom: 20px;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/zoom/zoom.component.css
// module id = ./src/app/zoom/zoom.component.css
// module chunks = main